import "./App.css";
import Loader from "./components/loader";
import { Toaster } from "react-hot-toast";
import webRoutes from "./routes/pageRoutes";
import { Suspense, useEffect } from "react";
import PrivateRoute from "./routes/PrivateRoute";
import { Route, Routes, useLocation } from "react-router";
import { AUTH_MODAL_PATHS } from "./routes/authModal";

function App() {
  const location = useLocation();
  const { pathname, state } = location;
  const backgroundLocation = state?.backgroundLocation;

  useEffect(() => {
    window.scroll(0, 0);
  }, [pathname]);

  const routes = webRoutes?.map((item, index) => (
    <Route
      key={index}
      exact
      path={item.path}
      element={
        item?.isPrivate ? (
          <PrivateRoute>{item?.element}</PrivateRoute>
        ) : (
          item?.element
        )
      }
    />
  ));

  return (
    <div className="App">
      <Toaster position="top-center" reverseOrder={false} />
      <Suspense fallback={<Loader />}>
        <Routes location={backgroundLocation || location}>{routes}</Routes>
        <Routes>
          {backgroundLocation
            ? webRoutes
                ?.filter((item) => AUTH_MODAL_PATHS.includes(item.path))
                ?.map((item, index) => (
                  <Route
                    key={`modal-${index}`}
                    path={item.path}
                    element={item.element}
                  />
                ))
            : null}
        </Routes>
      </Suspense>
    </div>
  );
}

export default App;
